/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum SubjectCategory {
    BLACK = 'BLACK',
    CASINO_CEPI_GREY = 'CASINO_CEPI_GREY',
    CASINO_GREY = 'CASINO_GREY',
    DROPPER = 'DROPPER',
    DRUG_CEPI_GREY = 'DRUG_CEPI_GREY',
    DRUG_GREY = 'DRUG_GREY',
    GREY = 'GREY',
    POTENTIAL_SUSPECT = 'POTENTIAL_SUSPECT',
    POTENTIAL_VICTIM = 'POTENTIAL_VICTIM',
    PYRAMID_CEPI_GREY = 'PYRAMID_CEPI_GREY',
    PYRAMID_GREY = 'PYRAMID_GREY',
    VICTIM = 'VICTIM',
    WHITE_LIST = 'WHITE_LIST',
    WITNESS = 'WITNESS'
}

